import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function useLeaveWarning() {
  const location = useLocation();

  const isTournamentPage = /^\/tournament\/\d+(\/\d+)?$/.test(location.pathname);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!isTournamentPage) return;

      event.preventDefault();
      event.returnValue = ""; // Standard to trigger the browser dialog
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isTournamentPage]);

  useEffect(() => {
    const handlePopState = () => {
      if (!isTournamentPage) return;

      const confirmLeave = window.confirm("Are you sure you want to leave? Your progress may be lost.");
      if (!confirmLeave) {
        // Push current URL back if user cancels
        window.history.pushState(null, "", location.pathname);
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [isTournamentPage, location.pathname]);
}

export default useLeaveWarning;
